
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

export default class NotFound extends Vue {
  @Prop({ type: String }) readonly item: string = 'item'
}
